import React from "react"
import badge from "badges/met-weekly-goal.svg"
import { BadgeImage } from "backpack/badges/styled"

const MetWeeklyGoal = props => <BadgeImage src={badge} {...props} />

export default MetWeeklyGoal
